module.exports = __webpack_public_path__ + "img/flag-fr2.f36653bd.svg";